import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { OpenResource } from '@shared/src/dtos/open/OpenResource';
import { PhaseSlotChangeReasonDataInfoDto } from '@shared/src/dtos/phase/slot/manage/reason/PhaseSlotChangeReasonDataInfoDto';
import { SlotChangeReasonItemDto } from '@shared/src/dtos/slotchangereason/SlotChangeReasonItemDto';
import { PhaseSlotChangeReasonManageDto } from '@shared/src/dtos/phase/slot/manage/reason/PhaseSlotChangeReasonManageDto';
import { PhaseSlotChangeReasonActionTypes } from '@shared/src/enums/PhaseSlotChangeReasonActionTypes';
import { DateFilter, HDate, HHour, HHourInterval, HString } from '@shared/src/public-api';
import { OpenSlotChangeReasonDto } from '@shared/src/dtos/open/OpenSlotChangeReasonDto';

@Component({
  selector: 'shared-exwork-phase-slot-change-reason-manage-component',
  templateUrl: './shared.exwork.phase.slot.change.reason.manage.component.html',
  styleUrls: ['./shared.exwork.phase.slot.change.reason.manage.component.scss'],
})
export class SharedExworkPhaseSlotChangeReasonManageComponent implements OnInit {

  constructor(public openRouteController: OpenRouteController, protected translateService: TranslateService) {
  }
 
  @Input()
  public driver: boolean = false;

  @Input() public readonly: boolean = false;
  public value: PhaseSlotChangeReasonManageDto;
  public objTranslate: any;

  private _phaseId: number;
  @Input() set phaseId(value: number) {
    if (this._phaseId === value)
      return;
    this._phaseId = value;
    this.loadData();
  }
  get phaseId(): number {
    return this._phaseId;
  }

  private _dataInfo: PhaseSlotChangeReasonDataInfoDto;
  @Input() set dataInfo(value: PhaseSlotChangeReasonDataInfoDto) {
    if (this._dataInfo === value)
      return;
    this._dataInfo = value;
    this.loadData();
  }
  get dataInfo(): PhaseSlotChangeReasonDataInfoDto {
    return this._dataInfo;
  }

  ngOnInit() {

  }

  loadData() {

    if (this.phaseId == null || this.dataInfo == null)
      return;
  
    if(this.dataInfo.action == PhaseSlotChangeReasonActionTypes.SetSlotExwork || this.dataInfo.action == PhaseSlotChangeReasonActionTypes.CancelSlotExwork || this.dataInfo.action == PhaseSlotChangeReasonActionTypes.SetSlotDriver || 
      this.dataInfo.action == PhaseSlotChangeReasonActionTypes.CancelSlotDriver){
      this.openRouteController.getExworkSlotChangeReasonManage(this.phaseId, this.dataInfo.action).subscribe(data => {
        this.welcome(data);
      });
    }else
      this.welcome(null);

  }

  welcome(data: PhaseSlotChangeReasonManageDto) {
    this.value = data;
    if (this.value != null && this.value.phaseSlot != null) {
      this.objTranslate = {};

      this.objTranslate.weekDay = this.translateService.instant(HDate.getDayOfWeek(this.value.phaseSlot.onDateSlot));
      this.objTranslate.date = DateFilter.getTransform(this.value.phaseSlot.onDateSlot);
      this.objTranslate.lapseTime = HHourInterval.toScreenString(this.value.phaseSlot.intervalSlot);

      this.objTranslate.dateOperant = HHour.getHourString(HHourInterval.getStarts(this.value.phaseSlot.intervalSlot));
      this.objTranslate.hourOperant = HHour.getHourString(HHourInterval.getEnds(this.value.phaseSlot.intervalSlot));
    }
    this.loadNextSlotChangeReason();
  }

  loadNextSlotChangeReason() {
    if (this.value == null || this.value.slotChangeReasons == null || this.value.slotChangeReasons.length == 0) {
      this.incompletReasons = true;
      this.incompletActualReasons = true;
      this.disabledButton = true;
      this.tenantsIncompletReason = new Array();
      return;
    }

    let reason = null;
    this.value.slotChangeReasons.forEach(element => {
      if (reason == null) {
        if (HLong.isNullOrNullLong(element.slotChangeReasonId))
          reason = element;
        else if (element.isRequiredComment && HString.isNullOrNullString(element.comment))
          reason = element;
      }
    });

    this.phaseSlotChangeReasonItem = reason;

    this.refreshIncompleteReasons();

    if(this.phaseSlotChangeReasonItem != null){
      this.openRouteController.getAllExworkSlotChangeReasonByTenantId(this.phaseSlotChangeReasonItem.tenantId).subscribe(data  => {
          this.slotChangeReasons = data;
      });
    }else{
      this.slotChangeReasons = new Array();
    }

  }

  public slotChangeReasons: Array<OpenSlotChangeReasonDto> = new Array();

  private _phaseSlotChangeReasonItem: SlotChangeReasonItemDto;
  set phaseSlotChangeReasonItem(value: SlotChangeReasonItemDto) {
    if (this._phaseSlotChangeReasonItem === value)
      return;
    this._phaseSlotChangeReasonItem = value;
  }
  get phaseSlotChangeReasonItem(): SlotChangeReasonItemDto {
    return this._phaseSlotChangeReasonItem;
  }

  public comment: string = "";
  public slotChangeReasonChangedEvent(value: OpenSlotChangeReasonDto) {
    if (value != null && this.phaseSlotChangeReasonItem != null) {
        this.phaseSlotChangeReasonItem.slotChangeReasonId = value.id;
        this.phaseSlotChangeReasonItem.isRequiredComment = value.isRequiredComment;
        this.refreshIncompleteReasons();
    }
  }

  getResourceKeyCaption(){
    if (this.dataInfo == null)
      return "SHARED.PHASESLOTCHANGEREASONMANAGE.CANCELSLOT.CAPTION";
    return "SHARED.PHASESLOTCHANGEREASONMANAGE." + this.dataInfo.action.toUpperCase() + ".CAPTION";
  }

  getResourceKeyComments(){

    if (this.phaseSlotChangeReasonItem != null && this.phaseSlotChangeReasonItem.isRequiredComment)
      return "SHARED.SLOTCHANGEREASONMANAGE.COMMENTS.REQUIREPLACEHOLDER";
    return "SHARED.SLOTCHANGEREASONMANAGE.COMMENTS.PLACEHOLDER";

  }

  getResourceButton() {
    var base: string = "SHARED.PHASESLOTCHANGEREASONMANAGE.";
  
    if(this.phaseSlotChangeReasonItem != null){
      if (this.value.slotChangeReasons.length > 1 && this.tenantsIncompletReason.length > 0 && !this.tenantsIncompletReason.includes(this.phaseSlotChangeReasonItem.tenantId)) 
        return base + "NEXT";
    }
     
    return base + this.dataInfo.action.toUpperCase() + ".BUTTON";
  }

  changeComment(value: string) {
    this.comment = value;
    this.refreshIncompleteReasons();
  }

  public disabledButton: boolean = true;
  public incompletReasons: boolean = true;
  public incompletActualReasons: boolean = true;
  public tenantsIncompletReason: number[];
  refreshIncompleteReasons() {
    
    if (this.value == null || this.value.slotChangeReasons == null || this.value.slotChangeReasons.length == 0) {
      this.incompletReasons = true;
      this.incompletActualReasons = true;
      this.disabledButton = true;
      this.tenantsIncompletReason = new Array();
      return;
    }

    //Traspassem a la llista les dades informades
    if(this.phaseSlotChangeReasonItem != null){
      this.value.slotChangeReasons.forEach(element => {
        if (this.phaseSlotChangeReasonItem.tenantId == element.tenantId) {
          element.slotChangeReasonId = this.phaseSlotChangeReasonItem.slotChangeReasonId;
          element.comment = this.phaseSlotChangeReasonItem.comment;
          element.isRequiredComment = this.phaseSlotChangeReasonItem.isRequiredComment;
        }
      });
    }

    let reason: number[] = new Array();

    this.value.slotChangeReasons.forEach(element => {
      if (HLong.isNullOrNullLong(element.slotChangeReasonId))
        reason.push(element.tenantId);
      else if (element.isRequiredComment && HString.isNullOrNullString(element.comment))
        reason.push(element.tenantId);
    });

    this.incompletActualReasons = this.phaseSlotChangeReasonItem != null && (HLong.isNullOrNullLong(this.phaseSlotChangeReasonItem.slotChangeReasonId) || (this.phaseSlotChangeReasonItem.isRequiredComment && HString.isNullOrNullString(this.comment)));
   
    this.disabledButton = this.incompletActualReasons;

    this.incompletReasons = reason.length > 0;
    this.tenantsIncompletReason = reason;

  }


  doPreAction(event) {
    this.loadNextSlotChangeReason();

    if (this.phaseSlotChangeReasonItem == null && !this.incompletReasons) {
      this.doAction();
    }
  }


  @Output()
  public onSaveReason: EventEmitter<any> = new EventEmitter();

  onFinishDoAction(value: Boolean){
    if(value)
      this.onSaveReason.next(true);
    else
      this.loadData();
  }
  
  doAction() {

    if(this.dataInfo == null || this.value == null)
      return;

    if(this.driver){
      if(this.dataInfo.action == PhaseSlotChangeReasonActionTypes.CancelSlotDriver){
    
        this.openRouteController.clearDriverPhaseSlot(this.dataInfo.uuid, this.phaseId, this.value.slotChangeReasons).subscribe(data => {
          this.onFinishDoAction(data);
        });

      }else if(this.dataInfo.action == PhaseSlotChangeReasonActionTypes.SetSlotDriver){
        if(this.dataInfo.addressinterval != null){
          if (!HLong.isNullOrNullLong(this.dataInfo.addressinterval.addressDaySettingResourceId)) {
            this.openRouteController.setDriverPhaseSlotByResource(this.dataInfo.uuid, this.phaseId, this.dataInfo.addressinterval.addressDaySettingResourceId, OpenResource.build(this.dataInfo.addressinterval), this.value.slotChangeReasons).subscribe(data => {
              this.onFinishDoAction(data);
            });
          } else if (!HLong.isNullOrNullLong(this.dataInfo.addressinterval.addressTimetableIntervalId)) {
              this.openRouteController.setDriverPhaseSlot(this.dataInfo.uuid, this.phaseId, this.dataInfo.addressinterval.addressTimetableIntervalId, this.value.slotChangeReasons).subscribe(data => {
                this.onFinishDoAction(data);
              });
          }
        }
      } 
    }else{
      if(this.dataInfo.action == PhaseSlotChangeReasonActionTypes.CancelSlotExwork){
    
        this.openRouteController.clearExworkPhaseSlot(this.dataInfo.uuid, this.phaseId, this.value.slotChangeReasons).subscribe(data => {
          this.onFinishDoAction(data);
        });

      }else if(this.dataInfo.action == PhaseSlotChangeReasonActionTypes.SetSlotExwork){
        if(this.dataInfo.addressinterval != null){
          if (!HLong.isNullOrNullLong(this.dataInfo.addressinterval.addressDaySettingResourceId)) {
            this.openRouteController.setExworkPhaseSlotByResource(this.dataInfo.uuid, this.phaseId, this.dataInfo.addressinterval.addressDaySettingResourceId, OpenResource.build(this.dataInfo.addressinterval), this.value.slotChangeReasons).subscribe(data => {
              this.onFinishDoAction(data);
            });
          } else if (!HLong.isNullOrNullLong(this.dataInfo.addressinterval.addressTimetableIntervalId)) {
              this.openRouteController.setExworkPhaseSlot(this.dataInfo.uuid, this.phaseId, this.dataInfo.addressinterval.addressTimetableIntervalId, this.value.slotChangeReasons).subscribe(data => {
                this.onFinishDoAction(data);
              });
          }
        }
      }    
    }
}

public pretty(value) {
    return JSON.stringify(value);
  }
}
